import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [tokenIsValid, setTokenIsValid] = useState(false);
    const [authToken, setAuthToken] = useState(null);

    useEffect(() => {
        const token = window.sessionStorage.getItem('authToken');
        const userData = JSON.parse(window.sessionStorage.getItem('user'));
        console.log('Getting token from first useEffect');
        console.log('token', token);
        if (token && userData) {
            setAuthToken(token);
            setUser(userData);
            setTokenIsValid(true);
        }
    }, []);

    useEffect(() => {
        setInterval(() => {
            const token = window.sessionStorage.getItem('authToken');
            validateToken(token).then((response) => {
                if (!response) {
                    setTokenIsValid(false);
                }
            });
        }, 60000);
    }, []);

    const login = async (email, password) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            if (response.ok) {
                const data = await response.json();
                setAuthToken(data.token);
                const userData = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/user?email=${email}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${data.token}` },
                });
                const user = await userData.json();
                setUser(user);
                window.sessionStorage.setItem('authToken', data.token);
                window.sessionStorage.setItem('user', JSON.stringify(user));
                return true;
            } else {
                const errorText = await response.text();
                throw new Error(errorText);
            }
        } catch (error) {
            console.error('Login error:', error.message);
            return false;
        }
    };

    const signup = async (email, password, name) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/signup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password, name }),
            });

            if (response.ok) {
                return await login(email, password);
            } else {
                const errorText = await response.text();
                throw new Error(errorText);
            }
        } catch (error) {
            console.error('Signup error:', error.message);
            return false;
        }
    };

    const logout = () => {
        setAuthToken(null);
        setUser(null);
        window.sessionStorage.removeItem('authToken');
        window.sessionStorage.removeItem('user');
    };

    const validateToken = async (token) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/validate-token`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            });

            if (response.ok) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Token validation error:', error.message);
            return false;
        }
    };

    return (
        <AuthContext.Provider value={{ user, authToken, tokenIsValid, login, signup, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
